import React from "react";
import { Icon } from "@iconify/react";

const EcommStats = ({ stats, loading }) => {
  const row1Items = [
    {
      label: "Total Orders",
      value: stats.totalOrders || 0,
      icon: "solar:cart-large-minimalistic-outline",
      color: "#364e3d",
      bg: "#edf1ee"
    },
    {
      label: "Paid Orders",
      value: stats.paidOrders || 0,
      icon: "solar:check-circle-outline",
      color: "#198754",
      bg: "#e8f5e9"
    },
    {
      label: "Failed Orders",
      value: stats.unpaidOrders || 0,
      icon: "solar:clock-circle-outline",
      color: "#ffc107",
      bg: "#fff9e6"
    }
  ];

  const row2Items = [
    {
      label: "Total Products",
      value: stats.totalProducts || 0,
      icon: "solar:box-outline",
      color: "#0d6efd",
      bg: "#e7f1ff"
    },
    {
      label: "Total Customers",
      value: stats.totalCustomers || 0,
      icon: "solar:users-group-two-rounded-outline",
      color: "#fd7e14",
      bg: "#fff5eb"
    },
    {
      label: "Total Revenue",
      value: `₹${(stats.totalRevenue || 0).toLocaleString("en-IN")}`,
      icon: "solar:wad-of-money-outline",
      color: "#dc3545",
      bg: "#fdf2f2"
    }
  ];

  const renderCard = (item, index) => (
    <div className="col-xxl-4 col-sm-4" key={index}>
      <div className="card h-100 p-0 radius-12 border-0 shadow-sm">
        <div className="card-body p-24">
          <div className="d-flex align-items-center justify-content-between gap-3">
            <div>
              <span className="fw-medium text-secondary-light mb-12 d-block" style={{ fontSize: '14px' }}>
                {item.label}
              </span>
              {loading ? (
                <div className="skeleton-line bg-light py-12 w-80-px radius-4"></div>
              ) : (
                <h4 className="fw-bold mb-0">{item.value}</h4>
              )}
            </div>
            <div
              className="w-56-px h-56-px d-flex justify-content-center align-items-center radius-12"
              style={{ backgroundColor: item.bg, color: item.color }}
            >
              <Icon icon={item.icon} width="28" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* 1st Row: Total Orders, Paid Orders, Unpaid Orders */}
      <div className="row gy-4 mb-4">
        {row1Items.map((item, index) => renderCard(item, index))}
      </div>

      {/* 2nd Row: Total Products, Total Customers, Total Revenue */}
      <div className="row gy-4 mb-4">
        {row2Items.map((item, index) => renderCard(item, index))}
      </div>
    </>
  );
};

export default EcommStats;
